import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  flex-direction: column;
  padding: 24px;
  margin-block: 32px;
`;

export const Ticket = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  border-left: 16px solid #5650bf;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  padding: calc(24px - (50px / 4)) 24px calc(24px - (50px / 4)) calc(24px - 6px);
  border-radius: 6px;
  margin-bottom: 16px;

  font-weight: 600;
  line-height: 19.84px;
`;

export const Title = styled('div')`
  font-weight: 700;
  line-height: 19.84px;
  margin-bottom: 24px;
`;

export const TotalTitle = styled(`div`)`
  font-weight: 700;
  line-height: 19.84px;
`;

export const TotalTextContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px 24px 0 12px;
`;

export const EmptyDescription = styled('span')``;
